class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.filterForm = this.querySelector("[data-role='filter']");
    this.sortForm = this.querySelector('[data-role="sort"]');
    this.sortElements = document.querySelectorAll('[data-action="sort"]');
    this.stickyFilter = document.querySelector(
      '[data-role="filter-sticky-mobile"]'
    );
    // debounce inputs change
    function debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    this.filterForm.addEventListener("input", (e) => {
      this.filterByAvailablity(e.target.getAttribute("name"));
      this.debouncedOnSubmit.call(this, e);
    });
    window.addEventListener("popstate", this.onHistoryChange.bind(this));
    this.sortForm.addEventListener("change", this.debouncedOnSubmit.bind(this));
    this.collectionFilterSticky.bind(this)();
  }

  forceUpdateWithParams(params) {
    // This public method allows external components to trigger a filter update.
    const fetchPromise = FacetFiltersForm.fetchData(params);
    FacetFiltersForm.updateHistory(params);
    return fetchPromise;
  }

  filterByAvailablity(name) {
    if (name != "filter.v.availability") {
      let inputs = this.querySelectorAll("input");
      let collection = false;
      let otherFilters = false;
      inputs.forEach((element) => {
        if (
          element.getAttribute("name") == "filter.p.m.custom.collection" &&
          element.checked
        ) {
          collection = true;
        } else if (
          element.checked &&
          element.getAttribute("name") != "filter.v.availability"
        ) {
          console.log("eee", element.getAttribute("name"));
          element.getAttribute("name") != "filter.p.m.custom.collection" &&
          element.getAttribute("name") != "layout-switch"
            ? (otherFilters = true)
            : "";
        }
      });
      if (collection && !otherFilters) {
        this.querySelectorAll("input[name='filter.v.availability']").forEach(
          (element) => (element.checked = false)
        );
      } else {
        this.querySelector(
          "input[name='filter.v.availability'][value='1']"
        ).checked = true;
        this.querySelector(
          "input[name='filter.v.availability'][value='0']"
        ).checked = false;
      }
    }
  }

  collectionFilterSticky() {
    this.stickyFilter.style.position = "sticky";
    this.stickyFilter.style.position = "z-index-100";
    this.stickyFilter.style.top = `${
      document.querySelector("[announcement-bar]").clientHeight +
      document.querySelector("header").clientHeight
    }px`;
  }

  static toggleDisplay() {
    let filterWrapper = document.querySelector("#filter_wrapper");
    if (filterWrapper.classList.contains("hidden")) {
      filterWrapper.classList.remove("hidden");
      document.body.style.overflowY = "hidden";
      setTimeout(() => {
        filterWrapper.style.opacity = "1";
      }, 300);
    } else {
      filterWrapper.style.opacity = "0";
      document.body.style.overflowY = "auto";
      setTimeout(() => {
        filterWrapper.classList.add("hidden");
      }, 300);
    }
  }
  // form submission handle
  onSubmitHandler = (e) => {
    e.preventDefault();
    const params = FacetFiltersForm.generateParams();
    FacetFiltersForm.fetchData(params);
    FacetFiltersForm.updateHistory(params);
  };
  static clearFilters() {
    let params = window.location.pathname.includes("/search")
      ? window.location.search.split("filter")[0].replace("?", "")
      : "";
    document.querySelector('[data-role="sort"]').querySelector("select").value =
      "";
    FacetFiltersForm.fetchData(params);
    FacetFiltersForm.updateHistory(params);
    Array.from(document.querySelectorAll("sort-by")).forEach((el) => {
      el.querySelector(".active")?.classList.remove("active");
    })

    const collectionCategoryFilter = document.querySelector('collection-category-filter');
    if (collectionCategoryFilter) {
      collectionCategoryFilter.resetActiveState();
    }
  }

  //on history chane
  onHistoryChange = () => {
    const params = window.location.search.replace("?", "");
    FacetFiltersForm.fetchData(params);
  };

  // generate params
  static generateParams() {
    let filterForm = document.querySelector("[data-role='filter']");
    let sortForm = document.querySelector('[data-role="sort"]');
    let searchQuery =
      window.location.pathname == "/search"
        ? window.location.search.split("&filter")[0].replace("?", "")
        : "";

    let filterQueryParams = new URLSearchParams(
      new FormData(filterForm)
    ).toString();
    let sortQueryParams = new URLSearchParams(
      new FormData(sortForm)
    ).toString();
    let params =
      searchQuery != ""
        ? `${searchQuery}&${filterQueryParams}&${sortQueryParams}`
        : `${filterQueryParams}&${sortQueryParams}`;
    return FacetFiltersForm._injectCategoryState(params);
  }

  static _injectCategoryState(paramsString) {
    const incomingParams = new URLSearchParams(paramsString);
    const categoryParams = new URLSearchParams();

    // The body tag is the single source of truth for category state.
    // We build the category params first in a separate object.
    if (document.body.dataset.mainCategory) {
      categoryParams.set('filter.p.m.custom.category', document.body.dataset.mainCategory);
    }
    if (document.body.dataset.subCategory) {
      categoryParams.set('filter.p.m.custom.sub_category', document.body.dataset.subCategory);
    }

    // Ensure incoming params do not contain category filters that will be prepended.
    incomingParams.delete('filter.p.m.custom.category');
    incomingParams.delete('filter.p.m.custom.sub_category');

    const finalParams = `${categoryParams.toString()}&${incomingParams.toString()}`;
    return finalParams.replace(/&+/g, '&').replace(/^&|&$/g, '');
  }

  // update history
  static updateHistory(params) {
    let updateUrl = `${window.location.pathname}?${params}`;
    window.history.pushState({ params }, "", updateUrl);
  }

  // fetch updated data
  static fetchData(params) {
    let sectionId = document.querySelector('[data-module="product-grid"]')
      .dataset.id;
    let elementsToFetch = [
      '[data-role="filter"]',
      '[data-module="product-grid"]',
      '[data-role="filters-count"]',
      '[data-action="desktop-removeFilter"]',
      "[data-pagination]",
      '[data-role="result-count"]',
    ];
    let url = `${window.location.pathname}?sections=${sectionId}&${params}`;
    document.querySelector('[data-module="product-grid"]').style.opacity =
      "0.5";
    return fetch(url)
      .then((res) => res.json())
      .then((data) => {
        let parser = new DOMParser();
        let html = parser.parseFromString(data[sectionId], "text/html");
        let collectionHtml = elementsToFetch.map((el) => ({
          element: el,
          content: html.querySelector(el),
        }));
        // render content
        FacetFiltersForm.renderContent(collectionHtml);
        document.querySelector('[data-module="product-grid"]').style.opacity =
          "1";
      })
      .catch((err) => console.error(err));
  }

  // render product grid
  static renderProductGrid(html) {
    let productGrid = document.querySelector('[data-module="product-grid"]');
    productGrid.innerHTML = html;
  }

  // render pagination
  static renderPaginate(html) {
    let paginateWrap = document.querySelector("[data-pagination]");
    paginateWrap.innerHTML = html;
  }

  // render filters
  static renderFilters(html) {
    let filterForm = document.querySelector('[data-role="filter"]');
    let openDetails = Array.from(filterForm.querySelectorAll("details[open]"));
    filterForm.innerHTML = html;
    openDetails.forEach((el) => {
      let details = filterForm.querySelector(
        `details[data-action="${el.dataset.action}"]`
      );
      if (details) {
        details.setAttribute("open", "open");
        FacetFiltersForm.adjustPopover(details);
      }
    });
  }

  // Adjust the desktop filter popover so a long list of values grows in rows
  // (taller) rather than in columns that overflow the viewport horizontally.
  static adjustPopover(details) {
    if (!details || window.innerWidth < 768) return;

    const ul = details.querySelector(".accordion-content > ul");
    if (!ul) return;

    const items = Array.from(ul.querySelectorAll(":scope > li")).filter(
      (li) => li.style.display !== "none"
    );
    const count = items.length;
    if (count === 0) return;

    const styles = getComputedStyle(ul);
    const isRTL = styles.direction === "rtl";
    const colGap = parseFloat(styles.columnGap) || 16;
    const colWidth = (items[0].offsetWidth || 124) + colGap;
    const margin = 24;

    // Reset any previous offset before measuring the natural position.
    ul.style.left = "";
    ul.style.right = "";

    const summaryRect = details
      .querySelector("summary")
      .getBoundingClientRect();
    const available = isRTL
      ? summaryRect.right - margin
      : window.innerWidth - summaryRect.left - margin;

    const maxCols = Math.max(1, Math.floor(available / colWidth));
    const colsAtDefault = Math.ceil(count / 6);
    const rows = colsAtDefault > maxCols ? Math.ceil(count / maxCols) : 6;
    ul.style.gridTemplateRows = `repeat(${rows}, max-content)`;

    // Anchor the popover to the trigger (left edge in LTR, right edge in RTL)
    // and, if it still spills past a viewport edge, nudge it back in.
    requestAnimationFrame(() => {
      if (isRTL) {
        ul.style.right = "0px";
        const rect = ul.getBoundingClientRect();
        let shift = 0;
        // Overflowing past the left edge -> move the popover to the right.
        if (rect.left < margin) {
          shift = margin - rect.left;
        }
        // ...but never past the right edge.
        if (rect.right + shift > window.innerWidth - margin) {
          shift = window.innerWidth - margin - rect.right;
        }
        ul.style.right = shift !== 0 ? `${-shift}px` : "0px";
      } else {
        ul.style.left = "0px";
        const rect = ul.getBoundingClientRect();
        let shift = 0;
        if (rect.right > window.innerWidth - margin) {
          shift = rect.right - (window.innerWidth - margin);
        }
        if (rect.left - shift < margin) {
          shift = rect.left - margin;
        }
        ul.style.left = shift !== 0 ? `-${shift}px` : "0px";
      }
    });
  }
  // render count
  static renderCount(html) {
    let countSpan = document.querySelector('[data-role="filters-count"]');
    countSpan.innerHTML = html;
    Number(countSpan.innerText) > 0
      ? countSpan.classList.remove("hidden")
      : countSpan.classList.add("hidden");
  }

  // render search result count
  static searchResultCount(html) {
    let resultCount = document.querySelector('[data-role="result-count"]');
    resultCount.innerHTML = html;
  }

  // render removeFilterDesktop
  static updateRemoveBtn(html) {
    let desktopRemoveBtn = document.querySelector(
      '[data-action="desktop-removeFilter"]'
    );
    html.classList.contains("md:hidden")
      ? desktopRemoveBtn.classList.add("md:hidden")
      : desktopRemoveBtn.classList.remove("md:hidden");
  }

  // render content
  static renderContent(html) {
    FacetFiltersForm.renderProductGrid(
      html.find((content) => content.element == '[data-module="product-grid"]')
        .content.innerHTML
    );

    FacetFiltersForm.renderFilters(
      html.find((content) => content.element == '[data-role="filter"]').content
        .innerHTML
    );

    FacetFiltersForm.renderCount(
      html.find((content) => content.element == '[data-role="filters-count"]')
        .content.innerHTML
    );

    FacetFiltersForm.updateRemoveBtn(
      html.find(
        (content) => content.element == '[data-action="desktop-removeFilter"]'
      ).content
    );

    FacetFiltersForm.renderPaginate(
      html.find((content) => content.element == "[data-pagination]").content
        .innerHTML
    );

    window.location.pathname == "/search"
      ? FacetFiltersForm.searchResultCount(
          html.find(
            (content) => content.element == '[data-role="result-count"]'
          ).content.innerHTML
        )
      : "";
  }
}
customElements.define("facet-filters-form", FacetFiltersForm);

//accordion btn
class accordion extends HTMLElement {
  constructor() {
    super();
    this.querySelector("summary").addEventListener("click", () => {
      if (window.innerWidth >= 768) {
        this.querySelector("details").getAttribute("open")
          ? this.querySelector("details").removeAttribute("open")
          : this.querySelector("details").setAttribute("open", "open");
      }
    });
    this.querySelector("details").addEventListener("click", function () {
      this.closest('[data-role="filter"]')
        ? Array.from(
            this.closest('[data-role="filter"]').querySelectorAll("details")
          ).forEach((el) => {
            el != this ? el.removeAttribute("open") : "";
          })
        : "";
    });
    this.querySelector("details").addEventListener("toggle", (e) => {
      if (e.target.open) FacetFiltersForm.adjustPopover(e.target);
    });
    document.addEventListener("click", (e) => {
      e.target != this && e.target.closest("accordion-btn") != this
        ? this.querySelector("details").removeAttribute("open")
        : "";
    });
  }
}
customElements.define("accordion-btn", accordion);

// sort btn
class SortBtn extends HTMLElement {
  constructor() {
    super();
    this.lists = this.querySelectorAll("li");

    Array.from(this.lists).forEach((el) => {
      el.addEventListener("click", this.toggleActive.bind(this, el));
      el.addEventListener("click", () => {
        this.querySelector("details").removeAttribute("open");
      });
    });
  }
  toggleActive(el) {
    Array.from(this.querySelectorAll("li")).forEach((li) => {
      li == el ? li.classList.add("active") : li.classList.remove("active");
    });
    SortBtn.submitFilter(el);
  }
  static submitFilter(el) {
    let event = new CustomEvent("change");
    let sortForm = document.querySelector('[data-role="sort"]');
    sortForm.querySelector('[name="sort_by"]').value = el.dataset.value;
    sortForm.dispatchEvent(event);
  }
}

customElements.define("sort-by", SortBtn);

// Re-flow any open desktop filter popover when the viewport size changes.
let filterResizeTimer;
window.addEventListener("resize", () => {
  clearTimeout(filterResizeTimer);
  filterResizeTimer = setTimeout(() => {
    document
      .querySelectorAll('[data-role="filter"] details[open]')
      .forEach((details) => FacetFiltersForm.adjustPopover(details));
  }, 150);
});

//filter toggle in mobile
document.addEventListener("click", (e) => {
  if (
    e.target.dataset.role == "filter-toggle" ||
    e.target.closest('[data-role="filter-toggle"]')
  ) {
    FacetFiltersForm.toggleDisplay();
  }
});
// clear filters
document.addEventListener("click", (e) => {
  if (
    e.target.dataset.role == "removeFilters" ||
    e.target.closest('[data-role="removeFilters"]')
  ) {
    e.preventDefault();
    FacetFiltersForm.clearFilters();
    window.innerWidth < 768 ? FacetFiltersForm.toggleDisplay() : "";
  }
});

//pagination
class Pagination extends HTMLElement {
  constructor() {
    super();
    this.behavior = this.dataset.behavior;
    this.productGrid = document.querySelector("search-product-grid")
      ? document.querySelector("search-product-grid")
      : document.querySelector("collection-product-grid");
    this.loadMoreBtn = document.querySelector('[data-role="paginate"]');
    this.btnClicked = false;

    this.loadMoreBtn
      ? this.loadMoreBtn.addEventListener("click", () => {
          this.btnClicked = true;
          this.loadMoreBtn.style.opacity = "0";
          this.fetchProduct.bind(this)();
        })
      : "";
    this.loadMoreBtn ? this.handleIntersection() : "";
  }

  // fetchProduct
  fetchProduct() {
    this.loadMoreBtn.classList.add("active");
    let url = window.location.pathname.includes("/search")
      ? `search/?sections=${
          this.dataset.section
        }&${window.location.search.replace("?", "")}&page=${
          this.loadMoreBtn.dataset.page
        }`
      : `${window.location.pathname}/?sections=${this.dataset.section}&page=${
          this.loadMoreBtn.dataset.page
        }&${window.location.search.replace("?", "")}`;
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        let sectionData = data[this.dataset.section];
        let parser = new DOMParser();
        let html = parser.parseFromString(sectionData, "text/html");
        this.renderContent(html);
        this.loadMoreBtn.classList.remove("active");
      });
  }

  // handle intersection
  handleIntersection() {
    const intersection = (entries) => {
      entries.map((entry) => {
        if (entry.isIntersecting) {
          if (this.btnClicked) {
            let clickEvent = new CustomEvent("click");
            entry.target.dispatchEvent(clickEvent);
          }
        }
      });
    };
    const options = {
      threshold: 1,
      rootMargin: "200px",
    };
    const observer = new IntersectionObserver(intersection, options);
    observer.observe(this.loadMoreBtn);
  }

  // renderProduct grid
  renderProductGrid(html) {
    let productGrid = document.querySelector(
      '[data-slot="product-grid-items"]'
    );
    productGrid.insertAdjacentHTML("beforeend", html.innerHTML);
  }

  //update load more button data attributes
  updateLoadMoreBtn(html) {
    let loadMoreBtn = document.querySelector('[data-role="paginate"]');
    html == null
      ? (loadMoreBtn.style.display = "none")
      : (loadMoreBtn.style.display = "inherit");
    html != null
      ? loadMoreBtn.setAttribute("data-page", html.dataset.page)
      : "";
    html != null ? (loadMoreBtn.innerHTML = html.innerHTML) : "";
  }

  // render content
  renderContent(html) {
    let sectionToLoad = [
      '[data-slot="product-grid-items"]',
      '[data-role="paginate"]',
    ];
    let content = sectionToLoad.map((section) => ({
      element: section,
      htmlContent: html.querySelector(section),
    }));
    this.renderProductGrid(
      content.find((el) => el.element == '[data-slot="product-grid-items"]')
        .htmlContent
    );
    this.updateLoadMoreBtn(
      content.find((el) => el.element == '[data-role="paginate"]').htmlContent
    );
  }
}

customElements.define("paginate-grid", Pagination);

// layout switch
class LayoutSwitch extends HTMLElement {
  constructor() {
    super();

    this.layout = "layout-1";
    // debounce inputs change
    function debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
    this.debounceChange = debounce((event) => {
      this.updateLayout(event.target.value);
    }, 500);

    this.addEventListener("change", this.debounceChange.bind(this));
  }
  updateLayout(layout) {
    let collectionProductGrid = document.querySelector(
      '[data-module="product-grid"]'
    );
    collectionProductGrid.classList.remove("layout-2");
    collectionProductGrid.classList.remove("layout-1");
    collectionProductGrid.classList.add(layout);
  }
}
customElements.define("layout-switch", LayoutSwitch);
